// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "@firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCGq7IzL8ZjU0TWhGkBmuQbrckGZxy9Vd0",
  authDomain: "festival-caav.firebaseapp.com",
  projectId: "festival-caav",
  storageBucket: "festival-caav.appspot.com",
  messagingSenderId: "1018635494442",
  appId: "1:1018635494442:web:e359b578497f44254e8f53",
  measurementId: "G-VM2GYZW775"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export {
    app,
    analytics,
    db
}